// extracted by mini-css-extract-plugin
module.exports = {"firstKv":"A_firstKv__90_qm"};